"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

require("../styles/_footer.scss");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function getBackProps(_ref) {
  var showPendingApprovalButtons = _ref.showPendingApprovalButtons,
      secondaryButtonText = _ref.secondaryButtonText,
      returnFeedback = _ref.returnFeedback,
      onBackClick = _ref.onBackClick;

  if (showPendingApprovalButtons) {
    return {
      onClickSecondary: returnFeedback,
      secondaryButtonText: 'Return Feedback'
    };
  }

  return {
    onClickSecondary: onBackClick,
    secondaryButtonText: secondaryButtonText || 'Back'
  };
}

function getCtaProps(_ref2) {
  var showPendingApprovalButtons = _ref2.showPendingApprovalButtons,
      showPendingApprovalInformation = _ref2.showPendingApprovalInformation,
      onNext = _ref2.onNext,
      openPaymentsInvoiceModal = _ref2.openPaymentsInvoiceModal,
      nextDisabled = _ref2.nextDisabled,
      nextBusy = _ref2.nextBusy,
      buttonText = _ref2.buttonText;

  if (showPendingApprovalInformation) {
    return {};
  }

  if (showPendingApprovalButtons) {
    return {
      onClickPrimary: openPaymentsInvoiceModal,
      primaryButtonText: 'Approve For Editing'
    };
  }

  return {
    primaryButtonDisabled: nextDisabled,
    primaryButtonBusy: nextBusy,
    onClickPrimary: onNext,
    primaryButtonText: buttonText || 'Continue'
  };
}

function Footer(props) {
  var showPendingApprovalInformation = props.showPendingApprovalInformation,
      children = props.children;
  return /*#__PURE__*/_react.default.createElement(_commonReact.NavigationFooter, _extends({}, getBackProps(props), getCtaProps(props)), showPendingApprovalInformation ? /*#__PURE__*/_react.default.createElement("div", {
    className: "footer__content__info footer__content__info__approval-required"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    name: "alert",
    color: "goldenTainoi"
  }), "This project brief is waiting for approval by your organisation admin") : null, children);
}

var _default = /*#__PURE__*/(0, _react.memo)(Footer);

exports.default = _default;